import React, { useEffect, useState } from "react";
import { Route, Redirect, RouteProps, useLocation } from "react-router";
import styled from "styled-components";

import { useUser } from "./index";
import { NewFeatures } from "../components/NewFeatures";
import { Navbar } from "../components/Navbar";
import { Link } from "react-router-dom";
import { useSubscription } from "./Subscription";
import { format, differenceInDays } from "date-fns";
import { FaExclamationTriangle } from "react-icons/fa";
import { RequireConfirmation } from "pages/ConfirmEmail/RequireConfirmation";
import axios from "axios";

const AlertBar = styled.div<{ color: string }>`
  background-color: ${(props) => props.theme.colors[props.color]};
  padding: 12px;
  color: white;
  text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    margin-right: 6px;
  }

  & a {
    color: white;
    text-decoration: underline;
    margin-left: 3px;

    &:hover {
      font-weight: 600;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

type AuthRouteProps = RouteProps;

const AuthenticatedRoute = (props: AuthRouteProps) => {
  const { user } = useUser();
  const [subscription] = useSubscription();
  const [showFeatures, setShowFeatures] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (user != null && location?.pathname != null) {
      axios.put("/api/account/track", { path: location.pathname });
    }
  }, [location?.pathname, user]);

  if (user == null) {
    return <Redirect to={"/login"} />;
  }

  if (user.emailConfirmed == null) {
    return <RequireConfirmation />;
  }

  return (
    <Container>
      <Navbar onShowFeatures={() => setShowFeatures((old) => !old)} />
      <NewFeatures
        shown={showFeatures}
        onClose={() => setShowFeatures(false)}
      />
      {subscription.type === "free-trial" &&
        differenceInDays(new Date(), new Date(subscription.periodEnd)) < 3 && (
          <AlertBar color="warning">
            <FaExclamationTriangle />
            Your free trial will expire on{" "}
            {format(new Date(subscription.periodEnd), "dd MMM yyyy")}.{" "}
            <Link to="/settings/subscription">
              Upgrade to a paid account to keep your timeboxing mojo.
            </Link>
          </AlertBar>
        )}
      {subscription.type === "expired" && (
        <AlertBar color="danger">
          <FaExclamationTriangle />
          Don't worry, your blocks are safe but your subscription has expired so
          they're hidden.{" "}
          <Link to="/settings/subscription">
            Upgrade to a paid account to get them back.
          </Link>
        </AlertBar>
      )}
      <Route {...props} />
    </Container>
  );
};

export default AuthenticatedRoute;
